export const getUserMessages = state => state.userMessages.data;
